import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { VolumeX, X } from "lucide-react";
import narration from "../data/narration.json";
import { soundEnabled, playVoice, stopVoice, isFirstVisit } from "../lib/regalVoice";

function lineKey(path) {
  if (path === "/shop" || path.startsWith("/collections")) return "shop";
  if (path.startsWith("/product/")) return "product";
  if (path === "/wishlist") return "wishlist";
  if (path === "/book") return "book";
  if (path.startsWith("/education")) return "education";
  if (path === "/contact") return "contact";
  if (path === "/finder") return "finder";
  if (path === "/stories") return "stories";
  return null;
}

// After the visitor's first interaction, Mr. Regal speaks a contextual line on each page navigation
export function RegalVoiceLayer() {
  const { pathname } = useLocation();
  const [line, setLine] = useState(null);
  const lastKey = useRef(null);
  const hideTimer = useRef(null);

  useEffect(() => {
    clearTimeout(hideTimer.current);
    const key = lineKey(pathname);
    if (!key) {
      lastKey.current = null;
      setLine(null);
      stopVoice();
      return undefined;
    }
    if (key === lastKey.current) return undefined;
    lastKey.current = key;
    setLine(null);
    if (!isFirstVisit() || !soundEnabled()) return undefined;
    const a = playVoice(`/audio/line-${key}.mp3`);
    if (!a) return undefined;
    setLine({ key, text: narration.pageLines[key] });
    const clear = () => setLine(null);
    a.onended = clear;
    hideTimer.current = setTimeout(clear, 14000);
    return () => clearTimeout(hideTimer.current);
  }, [pathname]);

  if (!line) return null;
  return (
    <div className="rj-voiceline" data-testid="voice-line-bar" aria-live="polite">
      <img src="/mr-regal-welcome.webp" alt="" aria-hidden="true" />
      <p data-testid="voice-line-text">“{line.text}”</p>
      <button
        onClick={() => { sessionStorage.setItem("rw_sound", "0"); stopVoice(); setLine(null); }}
        aria-label="Turn Mr. Regal's voice off"
        data-testid="voice-line-mute"
      >
        <VolumeX size={14} />
      </button>
      <button onClick={() => { stopVoice(); setLine(null); }} aria-label="Dismiss" data-testid="voice-line-stop">
        <X size={14} />
      </button>
    </div>
  );
}
